const highlights = [
  { icon: "ri-newspaper-line", title: "资讯速递", desc: "第一时间掌握影视动态与行业热点" },
  { icon: "ri-compass-3-line", title: "精准推荐", desc: "涵盖电影、电视剧、综艺的多元内容" },
  { icon: "ri-heart-3-line", title: "收藏记录", desc: "喜欢的作品随时收藏，浏览足迹自动留存" },
];

export default function BrandIntro() {
  return (
    <section className="mx-auto w-full px-4 py-14 md:px-6">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
            <i className="ri-fire-line" />
            关于糖心传媒
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            你的影视世界，
            <br />
            从糖心传媒开始
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            糖心传媒是一个面向影视爱好者的综合内容平台。我们汇聚最新影视作品与丰富资讯，覆盖电影、电视剧与综艺三大板块，让你在信息繁杂的时代里，依然能快速找到真正想看的那一部。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            无论是查找一部影片的评分与简介，还是浏览最新的行业动态，糖心传媒都希望成为你观影路上贴心的向导。分类清晰、筛选便捷、推荐真诚——这就是我们想做的影视门户。
          </p>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-1">
          {highlights.map((h) => (
            <div
              key={h.title}
              className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-100 p-5"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className={`${h.icon} text-xl`} />
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950">{h.title}</h3>
                <p className="mt-1 text-sm text-foreground-600">{h.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}